import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store';
import { selectOrderId } from './order/base';
import { getStepData } from '@components/sales/sales-wizard/sales-wizard-menu';
import { selectIsVarebilEnabled } from './order/implied';

export const selectCurrentStep = (state: RootState) => {
  return state.app?.currentStep;
};

export const selectSalesRootUrl = (state: RootState) => {
  return state.app?.salesRootUrl;
};

// Implied

export const selectStepData = createSelector(
  [selectCurrentStep, selectOrderId, selectSalesRootUrl, selectIsVarebilEnabled],
  (currentStep, orderId, rootUrl, isVarebilEnabled) => {
    return getStepData(currentStep, orderId, rootUrl, isVarebilEnabled);
  }
);
